export default {
  elevation1: {
    boxShadow: '0 20px 20px -10px rgba(204, 216, 214, 0.7);',
  },
  rounded: {
    borderRadius: 6,
  },
};
